// extracted by mini-css-extract-plugin
export default {"title":"ThirdScreenBrides_title__nV4er"};